import { Uuid } from '../../models/Base';
import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { sumNumberRecords } from '../../utils/object';
import { RepositoryElement } from '../Repository';

export type GameStatisticsKey =
  | 'normalScoreTotal'
  | 'normalPlayCount'
  | 'assistedScoreTotal'
  | 'assistedPlayCount'
  | 'revisionScoreTotal'
  | 'revisionPlayCount'
  | 'challengeScoreTotal'
  | 'challengePlayCount'
  | 'likeCount'
  | 'angelPlayCount';

export interface GameStatisticsJson {
  readonly gameId: Uuid; // identifier,
  statistics: Partial<Record<GameStatisticsKey, number>>;
}

export class GameStatistics
  extends RepositoryElement
  implements GameStatisticsJson
{
  readonly gameId!: Uuid; // identifier,
  statistics!: Partial<Record<GameStatisticsKey, number>>;

  // lastModifiedAt?: Date; // TODO: lock for at least 30s?

  constructor(gameStatistics: GameStatisticsJson) {
    super();
    // although no timestamp, still use deepTransformTimestamp to deep copy
    Object.assign(this, deepTransformTimestamp(gameStatistics));
  }

  get playCount(): number {
    const { normalPlayCount = 0, revisionPlayCount = 0 } = this.statistics;
    return normalPlayCount + revisionPlayCount;
  }

  get averageScore(): number {
    const playCount = this.playCount;
    const { normalScoreTotal = 0, revisionScoreTotal = 0 } = this.statistics;
    return playCount > 0
      ? (normalScoreTotal + revisionScoreTotal) / playCount
      : 0;
  }

  get averageAssistedScore(): number {
    const { assistedPlayCount = 0, assistedScoreTotal = 0 } = this.statistics;
    return assistedPlayCount > 0 ? assistedScoreTotal / assistedPlayCount : 0;
  }

  id(): string {
    return this.gameId;
  }

  toJSON(): GameStatisticsJson {
    return deepTransformDate(this) as unknown as GameStatisticsJson;
  }

  incrementStatistics(statistics: Partial<Record<GameStatisticsKey, number>>) {
    sumNumberRecords(this.statistics, statistics);
  }
}
